export default __webpack_public_path__ + "static/media/39.c9b35ccb.jpg";